<template>
    <div class="modal-content m-selectionProducts">
        <!-- Modal Header -->
        <div class="modal-header bg-1">
            <modal-close />
            <div class="modal-title my-1">
                <h2 class="h3 mb-0">
                    Wybierz produkty
                    <span>
                        ({{ `${selectedProducts.length} / ${productsLimit}` }})
                    </span>
                </h2>
            </div>
        </div>

        <!-- Modal Body -->
        <div class="modal-body pt-0 pb-4 px-3">
            <div
                class="row position-sticky pt-4"
                style="top: -12px; background-color: var(--color-white); z-index: 9;"
            >
                <div class="col-md-6">
                    <search-input
                        @change="
                            requestParams.name = $event
                            fetch(1)
                        "
                        class="w-100"
                        :search-input="requestParams.name"
                        :search-params-tooltip="['nazwie produktu', 'kodzie EAN']"
                    />
                </div>
            </div>

            <div
                v-if="requestParams.name.length < 3 && !isWalkthrough"
                v-text="'Użyj wyszukiwarki, by wyświetlić produkty'"
            />
            <div
                v-else-if="
                    isWalkthrough || (dictProducts && dictProducts.length)
                "
                class="m-selectionProducts__productList"
            >
                <div class="c-table table-selection-products">
                    <div class="c-thead p-0">
                        <div class="c-td is-1" v-text="'Nazwa produktu'" />
                        <div class="c-td is-2" v-text="'EAN'" />
                        <div class="c-td is-3"></div>
                    </div>
                    <div class="c-tbody" style="position: relative">
                        <page-preloader
                            mode="wrapper"
                            :style="{
                                minHeight:
                                    dictProductsStatus === 'loading'
                                        ? '3rem'
                                        : 'auto'
                            }"
                            :is-loading="dictProductsStatus === 'loading'"
                        >
                            <div
                                class="c-tr px-0"
                                v-for="product in dictProducts"
                                :key="product.id"
                                style="min-height: 3rem;"
                            >
                                <div class="c-td is-1" v-text="product.name" />
                                <div class="c-td is-2" v-text="product.ean" />
                                <div class="c-td is-3 text-right">
                                    <div
                                        v-if="isProductSelected(product)"
                                        v-tooltip="
                                            'Po kliknięciu w przycisk „Wybrano” towar zostanie usunięty z koszyka'
                                        "
                                    >
                                        <the-btn
                                            class="btn-secondary"
                                            @click.native="
                                                onAddOrRemoveProduct(product)
                                            "
                                        >
                                            Wybrano
                                        </the-btn>
                                    </div>
                                    <div
                                        v-else
                                        v-tooltip="{
                                            content: isProductsLimitReached
                                                ? `Osiągnięto limit produktów (${productsLimit})`
                                                : ''
                                        }"
                                    >
                                        <the-btn
                                            class="btn-outline-custom"
                                            :disabled="isProductsLimitReached"
                                            @click.native="
                                                onAddOrRemoveProduct(product)
                                            "
                                        >
                                            Wybierz
                                        </the-btn>
                                    </div>
                                </div>
                            </div>
                        </page-preloader>
                    </div>
                </div>
            </div>
            <div v-else-if="dictProductsStatus === 'loading'">
                <page-preloader
                    :min-height="'4rem'"
                    :is-loading="dictProductsStatus === 'loading'"
                />
            </div>
            <div v-else>
                Nie znaleziono produktu w bazie lub produkt nie jest obsługiwany
                w wybranym przez Ciebie mechanizmie promocyjnym.
            </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer" style="position: sticky; bottom: 0;">
            <the-pagination
                v-if="dictProducts && dictProducts.length"
                :pagination="dictProductsPagination"
                @change="fetch"
            />
            <the-btn
                class="ml-auto"
                @click.native="$store.dispatch('toggleModal', false)"
            >
                Zapisz
            </the-btn>
        </div>
    </div>
</template>

<script>
import { addNewPromo } from '@/mixins/addNewPromo'
export default {
    name: 'AddPromoSelectionProducts',

    mixins: [addNewPromo],

    data() {
        return {
            requestParams: {
                name: '',
                page: 1,
                main: true,
                per: 10,
                sort: 'name',
                includes: 'image'
            },
            recentlySelected: []
        }
    },

    computed: {
        dictProducts() {
            return this.$store.getters.getDictProducts
        },

        dictProductsStatus() {
            return this.$store.getters.getDictProductsStatus
        },

        dictProductsPagination() {
            return this.$store.getters.getDictProductsPagination
        },

        modalArgs() {
            return this.$store.getters.modalState.args
        },

        isWalkthrough() {
            return this.$store.getters.getWalkthroughActive
        }
    },

    methods: {
        isProductSelected(product) {
            return this.selectedProducts.find(el => el.id === product.id)
        },

        fetch(page) {
            if (page) {
                this.requestParams.page = page
            }

            const params = { ...this.requestParams }
            for (const [key, value] of Object.entries(this.requestParams)) {
                if (value === '' || value === null || value === undefined) {
                    delete params[key]
                }
            }

            if (this.requestParams.name?.length > 2) {
                this.$store.dispatch('dictProductsFetch', {
                    page,
                    params
                })
            } else {
                this.$store.dispatch('clearDictProducts')
            }
        },

        async onAddOrRemoveProduct(product) {
            const { setIdx } = this.modalArgs

            if (this.isProductSelected(product)) {
                const idx = this.recentlySelected.indexOf(product.id)
                this.recentlySelected.splice(idx, 1)
            } else {
                this.recentlySelected.push(product.id)
            }

            const value = this.toggleProduct(product, setIdx)

            await this.$store.dispatch('fetchSubProducts', {
                product,
                setIdx,
                isMix: this.isMix
            })

            if (product.ean_present || !value || setIdx) return

            this.$store.dispatch('setMerchantEanToNewPromoProduct', product)
        }
    },

    beforeDestroy() {
        this.$store.dispatch('clearDictProducts')

        const recentlySelected = document.querySelectorAll(
            '.--recentlySelected'
        )
        recentlySelected.forEach(tr => {
            setTimeout(() => {
                tr.classList.add('--transition')
                tr.classList.remove('--recentlySelected')
                setTimeout(() => {
                    tr.classList.remove('--transition')
                }, 3000)
            }, 1000)
        })
    },

    async created() {
        if (this.isWalkthrough) {
            return
        }

        this.$store.dispatch('setRecentlySelectedProducts', [])

        const { params } = this.modalArgs

        for (const key in params) {
            if (Object.hasOwnProperty.call(params, key)) {
                this.$set(this.requestParams, key, params[key])
            }
        }

        await this.fetch()
    },

    mounted() {},

    watch: {
        recentlySelected() {
            this.$store.dispatch(
                'setRecentlySelectedProducts',
                this.recentlySelected
            )
        }
    }
}
</script>
